import {useCallback} from 'react';

import {KYC_SOURCE_OF_FUNDS_EVENTS} from '@/app/auth/events/KycSourceOfFundsEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

import {KycSourceOfFundsOptionId} from './constants';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackSelectSourceOfFunds = useCallback(
    (sourceOfFunds: KycSourceOfFundsOptionId) => {
      trackEvent(KYC_SOURCE_OF_FUNDS_EVENTS.SELECT_SOURCE_OF_FUNDS, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        Fintech: {
          funds: {
            source: sourceOfFunds,
          },
        },
      });
    },
    [trackEvent],
  );

  return {
    trackSelectSourceOfFunds,
  };
};
